<div class="datatable-page-header">
  <h1>
    <ng-container *ngIf="groupId">
      <a routerLink="../../" mat-icon-button class="back-button">
        <mat-icon svgIcon="arrow-back"></mat-icon>
      </a>
      <span *ngIf="group$ | async as group" trans [transValues]="{groupName: group.name}">
        Links for ":groupName"
      </span>
    </ng-container>
    <span *ngIf="!groupId" trans>Links</span>
  </h1>

  <div class="header">
    <datatable-filters pluralName="links" [filters]="filters"></datatable-filters>
    <div class="action-buttons">
      <button mat-raised-button class="btn-with-dropdown-icon" [matMenuTriggerFor]="menu">
        <span trans>More Actions</span>
        <mat-icon svgIcon="keyboard-arrow-down"></mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <permission-aware-button permission="link_groups.update" *ngIf="groupId">
          <button mat-menu-item (click)="showAttachLinksToGroupModal()">
            <mat-icon svgIcon="shortcut"></mat-icon>
            <span trans>Move existing links to this group</span>
          </button>
        </permission-aware-button>
        <permission-aware-button permission="links.create">
          <button mat-menu-item (click)="showCrupdateLinkModal(null, true)">
            <mat-icon svgIcon="add-link"></mat-icon>
            <span trans>{{groupId ? 'Add multiple links' : 'Shorten multiple links'}}</span>
          </button>
        </permission-aware-button>
        <button mat-menu-item (click)="exportCsv()">
          <mat-icon svgIcon="export-csv"></mat-icon>
          <span trans>Export links in CSV</span>
        </button>
      </mat-menu>
      <permission-aware-button permission="links.create">
        <button
          mat-raised-button
          color="accent"
          (click)="showCrupdateLinkModal()"
          class="button-with-icon"
        >
          <mat-icon svgIcon="add"></mat-icon>
          <span trans>{{groupId ? 'Add Link' : 'Shorten Link'}}</span>
        </button>
      </permission-aware-button>
    </div>
  </div>
</div>

<div class="datatable responsive-table">
  <mat-progress-bar
    class="loading-bar"
    mode="indeterminate"
    color="accent"
    *ngIf="datatable.paginator && datatable.paginator.loading$ | async"
  ></mat-progress-bar>
  <table class="material-table">
    <thead>
      <tr>
        <th table-header-checkbox></th>
        <th trans>Summary</th>
        <ng-container *ngIf="showUserColumn()">
          <th table-sort-header="user_id" trans>Owner</th>
        </ng-container>
        <th table-sort-header="clicks_count">Clicks</th>
        <th table-sort-header trans>Type</th>
        <th table-sort-header trans>Password</th>
        <th table-sort-header="expires_at" trans>Expires At</th>
        <th table-sort-header="clicked_at" trans>Last Clicked</th>
        <th></th>
      </tr>
      <tr *ngIf="datatable.selectedRows$.value.length as selectedCount">
        <th colspan="9">
          <div
            class="bulk-actions-title"
            [transValues]="{count: selectedCount, resource: 'link(s)'}"
            trans
          >
            :count :resource selected:
          </div>
          <div class="bulk-actions">
            <button
              type="button"
              mat-raised-button
              color="accent"
              *ngIf="groupId"
              (click)="maybeDetachLinksFromGroup()"
              trans
            >
              Detach from group
            </button>
            <permission-aware-button permission="links.delete">
              <button
                type="button"
                mat-raised-button
                color="warn"
                (click)="maybeDeleteSelectedLinks()"
                trans
              >
                Delete
              </button>
            </permission-aware-button>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let link of links$ | async">
        <td [table-body-checkbox]="link.id"></td>
        <td class="link-summary-column mobile-no-label">
          <a class="long-url" [href]="link.long_url" target="_blank">
            <img class="favicon-img" [src]="link.long_url | favicon" alt="Link favicon" />
            <span>{{ link.long_url | removeProtocol | slice: 0:50 }}</span>
          </a>
          <div class="short-url">
            <a [href]="link.short_url" target="_blank">{{ link.short_url }}</a>
          </div>
        </td>
        <td data-label="Owner" *ngIf="showUserColumn()">
          <user-column [user]="link.user"></user-column>
        </td>
        <td data-label="Clicks">{{ link.clicks_count | number }}</td>
        <td data-label="Type" class="capitalize">{{ link.type }}</td>
        <td data-label="Password">
          <mat-icon svgIcon="check" *ngIf="link.has_password"></mat-icon>
          <span *ngIf="!link.has_password">-</span>
        </td>
        <td data-label="Expires At">
          {{
            link.deleted_at
              ? ('Expired' | trans)
              : link.expires_at
              ? (link.expires_at | formattedDate)
              : '-'
          }}
        </td>
        <td data-label="Last Clicked">{{ link.clicked_at ? (link.clicked_at | formattedDate) : '-' }}</td>
        <td class="edit-column">
          <a
            mat-icon-button
            [routerLink]="['/', getParentRoute(), 'links', link.id]"
            [matTooltip]="'Link Statistics' | trans"
          >
            <mat-icon svgIcon="analytics"></mat-icon>
          </a>
          <copy-link-btn [model]="link"></copy-link-btn>
          <permission-aware-button
            permission="links.update"
            [userOwnsResource]="link.user_id === this.currentUser.get('id')"
          >
            <button
              mat-icon-button
              (click)="showCrupdateLinkModal(link)"
              [matTooltip]="'Edit link' | trans"
            >
              <mat-icon svgIcon="edit"></mat-icon>
            </button>
          </permission-aware-button>
          <permission-aware-button
            permission="links.delete"
            [userOwnsResource]="link.user_id === this.currentUser.get('id')"
          >
            <button
              mat-icon-button
              class="visible-on-mobile"
              (click)="maybeDeleteSelectedLinks([link.id])"
              [matTooltip]="'Delete link' | trans"
            >
              <mat-icon svgIcon="delete"></mat-icon>
            </button>
          </permission-aware-button>
        </td>
      </tr>
    </tbody>
  </table>
  <no-results-message svgImage="share-link.svg" *ngIf="datatable.paginator.noResults$ | async">
    <span primary-text trans>No links have been added yet</span>
  </no-results-message>
  <datatable-footer></datatable-footer>
</div>
